import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SensorValuesComponent } from './components/sensor-values/sensor-values.component';
import { NgApexchartsModule } from 'ng-apexcharts';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { TranslocoModule } from '@ngneat/transloco';
import { BannerComponent } from './components/banner/banner.component';
import { FooterComponent } from './components/footer/footer.component';
import { MatButton, MatButtonModule } from '@angular/material/button';
import { FuseNavigationModule } from '@fuse/components/navigation';
import { RouterModule } from '@angular/router';
import { OverlayModule } from '@angular/cdk/overlay';
import { FaqSectionComponent } from './components/faq-section/faq-section.component';
import { MatExpansionModule } from '@angular/material/expansion';
import { SpeedOfLightComponent } from './components/speed-of-light/speed-of-light.component';
import { ThreePaneGalleryComponent } from './components/three-pane-gallery/three-pane-gallery.component';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { ContactUsComponent } from './components/contact-us/contact-us.component';
import { GoogleMapsModule } from '@angular/google-maps';
import { MatSelectModule } from '@angular/material/select';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { ImageTextCardComponent } from './components/image-text-card/image-text-card.component';
import { DirectBookingComponent } from './components/direct-booking/direct-booking.component';
import { MapComponent } from './components/map/map.component';
import { VideoComponent } from './components/video/video.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { RealEstateCardComponent } from './components/real-estate-card/real-estate-card.component';
import { StarInfoComponent } from './components/star-info/star-info.component';
import { LocationListComponent } from './components/location-list/location-list.component';
import { SensorsDialogComponent } from './components/sensors-dialog/sensors-dialog.component';
import {MatTooltipModule} from '@angular/material/tooltip';
import { FourPaneGalleryComponent } from './components/four-pane-gallery/four-pane-gallery.component';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MAT_MOMENT_DATE_FORMATS, MomentDateAdapter } from '@angular/material-moment-adapter';
import { UserProfileComponent } from 'app/modules/user/user-profile/user-profile.component';


@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        NgApexchartsModule,
        MatMenuModule,
        MatIconModule,
        MatButtonToggleModule,
        MatFormFieldModule,
        MatInputModule,
        MatCheckboxModule,
        MatButtonModule,
        MatSelectModule,
        MatAutocompleteModule,
        TranslocoModule,
        FuseNavigationModule,
        MatExpansionModule,
        RouterModule,
        OverlayModule,
        CarouselModule,
        GoogleMapsModule,
        MatTooltipModule,
        MatDatepickerModule,
        MatDialogModule,
    ],
    exports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        SensorValuesComponent,
        TranslocoModule,
        BannerComponent,
        FooterComponent,
        FaqSectionComponent,
        SpeedOfLightComponent,
        ThreePaneGalleryComponent,
        ContactUsComponent,
        MapComponent,
        VideoComponent,
        DirectBookingComponent,
        ImageTextCardComponent,
        RealEstateCardComponent,
        StarInfoComponent,
        FourPaneGalleryComponent,
        UserProfileComponent,
    ],
    providers: [
        { provide: MAT_DATE_LOCALE, useValue: 'de' },
        {
            provide: DateAdapter,
            useClass: MomentDateAdapter,
            deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
        },
        { provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS },
    ],
    declarations: [
        SensorValuesComponent,
        BannerComponent,
        FooterComponent,
        FaqSectionComponent,
        SpeedOfLightComponent,
        ThreePaneGalleryComponent,
        ContactUsComponent,
        MapComponent,
        VideoComponent,
        DirectBookingComponent,
        ImageTextCardComponent,
        RealEstateCardComponent,
        StarInfoComponent,
        LocationListComponent,
        SensorsDialogComponent,
        FourPaneGalleryComponent,
        UserProfileComponent,
    ],
})
export class SharedModule {}
